<template>
  <div class="custom-toast" v-if="visible">
    <div class="toast-content">
      <div class="toast-header">
        <div class="toast-title">{{ title }}</div>
      </div>
      <div class="toast-message">{{ message }}</div>
      <div class="toast-footer">
        <div class="toast-button" @click="close">{{ buttonText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomToast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '友情提示'
    },
    message: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: '关闭'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.custom-toast {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.toast-content {
  width: 80%;
  max-width: 300px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.toast-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}

.toast-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  width: 100%;
  display: flex;
  justify-content: center;
}

.toast-close {
  font-size: 20px;
  color: #999;
  cursor: pointer;
}

.toast-message {
  padding: 20px;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
}

.toast-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
}

.toast-button {
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  border-radius: 4px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.toast-button:hover {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/CustomToast.vue